import { useState } from "react";
import { ListFields } from "../types";
import { useTranslation } from "react-i18next";

interface UseEventModalReturn {
    showModal: boolean;
    modalData: {
        title: string;
        subtitle: string;
        subtitle2: string;
        countValues: number;
        bodyLabel: string;
        type: 'delete' | 'end' | 'info' | 'upload';
    };
    error: string;
    endDate: Date | null;
    startDate: Date | null;
    isLoading: boolean;
    setLoading: (loading: boolean) => void;
    closeModal: () => void;
    setEndDate: (date: Date | null) => void;
    setStartDate: (date: Date | null) => void;
    setError: (error: string) => void;
    onEndDateChange?: (date: Date | null) => void;
    openUploadModal: (title: string, subtitle: string, subtitle2: string) => void; // Added upload modal function
    setModalCount: (count: number) => void; // ADDED: New function to update the count
    openDeleteModal: (event: ListFields) => void;

}

export function useGenericModal(): UseEventModalReturn {
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(null);

    const { t } = useTranslation();

    const [modalData, setModalData] = useState<{
        title: string;
        subtitle: string;
        subtitle2: string;
        countValues: number,
        bodyLabel: string;
        type: 'delete' | 'end' | 'info' | 'upload';
    }>({
        title: "default",
        subtitle: "default",
        subtitle2: "default",
        countValues: 0,
        bodyLabel: "default",
        type: "delete"
    });

    // title: t("participant:modal.modalUpdateCSVParticipantsTitle"),
    //         subtitle: t("participant:modal.modalUpdateCSVParticipantsSubtitle"),
    //         subtitle2: t("participant:modal.modalUpdateCSVParticipantsSubtitleCampaing"),
    // New function for upload modal
    const openUploadModal = (title: string, subtitle: string, subtitle2: string = "") => {

        setShowModal(true);
        setModalData({
            title: t(title),
            subtitle: t(subtitle),
            subtitle2: t(subtitle2),
            bodyLabel: "",
            type: "upload",
            countValues: 0
        });
    };

    const openDeleteModal = (event: ListFields) => {

        setShowModal(true);
        setModalData({
            title: t("ModalDeleteEventTitle"),
            subtitle: t("ModalDeleteEventBody") + " " + event.description + "?",
            subtitle2: "",
            bodyLabel: "",
            type: "delete" as const,
            countValues: 0
        });
    };
    const closeModal = () => {
        setIsLoading(false); // Reset loading state al cerrar
        setShowModal(false);
        setError('')
    };

    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    const setModalCount = (count: number) => {
        setModalData(prevData => ({ ...prevData, countValues: count }));
    };

    return {
        showModal,
        modalData,
        error,
        endDate,
        startDate,
        openUploadModal,
        openDeleteModal,
        closeModal,
        setEndDate,
        setStartDate,
        setError,
        isLoading,
        setLoading,
        setModalCount
    };
}
